import { baseApi } from '../baseApi'
import type { Dictionary } from '@/types'

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<Dictionary, Record<string, any>>({
      query: () => ({
        url: `/settings`,
        method: 'GET',
      }),
      providesTags: ['Settings'],
      transformResponse: (response: any) => response.data,
    }),
    updateSettings: builder.mutation({
      query: (data) => ({
        url: `/settings`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Settings'],
    }),
  }),
})

export const { useUpdateSettingsMutation, useGetSettingsQuery } = settingsApi
